import React from "react";

import "./documentIcon.scss";

export interface DocumentIconProps {
  type: string;
}

const DocumentIcon: React.FC<DocumentIconProps> = (props) => {
  return (
    <div className="xgs-document-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="108" viewBox="0 0 80 108" fill="none">
        <path d="M71 1V74L76.5 74.5V93.5H71V107H1V20.5L20.5 1H71Z" fill="white" />
        <path d="M72 72H80V96H72V108H0V20L20 0H72V72ZM22 22H2V106H70V96H18V72H70V2H22V22ZM2.82812 20H20V2.82812L2.82812 20Z" fill="#2F80ED" />
        <path d="M36 61H12V57H36V61ZM60 53H12V49H60V53ZM60 45H12V41H60V45ZM60 37H12V33H60V37Z" fill="#2F80ED" fill-opacity="0.32" />
      </svg>
      <div className="xgs-document-icon__caption">{props.type}</div>
    </div>
  )
}

export default DocumentIcon;